import { ComponentType, PropsWithChildren, ReactElement } from 'react';

import {
  SnackbarProvider as Provider,
  SnackbarProviderProps,
  VariantType,
} from 'notistack';

import * as Icons from '../icons';
import {
  NotificationSnackbar,
  NotificationSnackbarProps,
} from './NotificationSnackbar';
import { SnackbarUtilsConfigurator } from './SnackbarUtilsConfigurator';

const icons: Record<VariantType, ReactElement> = {
  info: <Icons.Info />,
  success: <Icons.CheckCircle />,
  warning: <Icons.Warning />,
  error: <Icons.WarningCircle />,
};

const components: Record<
  VariantType,
  ComponentType<NotificationSnackbarProps>
> = {
  info: NotificationSnackbar,
  success: NotificationSnackbar,
  warning: NotificationSnackbar,
  error: NotificationSnackbar,
};

export const SnackbarsProvider = ({
  children,
  ...props
}: PropsWithChildren<Partial<SnackbarProviderProps>>) => {
  return (
    <Provider
      iconVariant={icons}
      Components={components}
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      {...props}
    >
      <SnackbarUtilsConfigurator />
      <>{children}</>
    </Provider>
  );
};
